<template>
  <div>
    <spinner-loader :loadingStuff="loadingStuff" />
    <app-template />
    <div class="uk-container uk-container-large">
      <div class="intro-header">
        <div class="header-buttons">
          <div v-if="selectedUserValue !== ''">
            <div class="user-photo-info">
              <img
                v-if="
                  selectedUserValue.userImage !== '' &&
                  selectedUserValue.userImage !== null
                "
                id="user_photo"
                :src="getImgUrl(selectedUserValue.userImage)"
                alt=""
              />
              <TenantLogo v-else logo-class="login-logo" />
              <h1>
                Scout <br />
                {{ selectedUserValue.name }}
              </h1>
            </div>
          </div>
          <h2 v-else>Scouts</h2>
        </div>
      </div>

      <template v-if="selectedUserValue !== ''">
        <ul class="tabs headding-space">
          <li class="tab-item">
            <a
              :class="
                selectedTab === 'contact-tab' ? 'tab-link active' : 'tab-link'
              "
              @click="tabChange('contact-tab')"
              href="javascript:;"
              >Contact information</a
            >
          </li>
          <li class="tab-item">
            <a
              :class="
                selectedTab === 'qualifications-tab'
                  ? 'tab-link active'
                  : 'tab-link'
              "
              @click="tabChange('qualifications-tab')"
              href="javascript:;"
              >Qualifications</a
            >
          </li>
          <li class="tab-item">
            <a
              :class="
                selectedTab === 'documents-tab' ? 'tab-link active' : 'tab-link'
              "
              @click="tabChange('documents-tab')"
              href="javascript:;"
              >Documents</a
            >
          </li>
          <li class="tab-item">
            <a
              :class="
                selectedTab === 'scout-card-tab'
                  ? 'tab-link active'
                  : 'tab-link'
              "
              @click="tabChange('scout-card-tab')"
              href="javascript:;"
              >Scout Card</a
            >
          </li>
        </ul>

        <div class="tabs-wrapper">
          <!-- Contact Information -->
          <div
            class="current-week-tab tab-content"
            v-if="selectedTab === 'contact-tab'"
          >
            <div class="games-info">
              <div class="personal-info">
                <div class="user-photo-info">
                  <img
                    v-if="
                      selectedUserValue.userImage !== '' &&
                      selectedUserValue.userImage !== null
                    "
                    :src="getImgUrl(selectedUserValue.userImage)"
                    alt=""
                  />
                  <TenantLogo v-else logo-class="login-logo" />
                </div>
                <div class="item">
                  <span class="label">Name:</span>
                  <span class="value">{{ selectedUserValue.name }}</span>
                </div>
                <div class="item">
                  <span class="label">Email:</span>
                  <span class="value">{{ selectedUserValue.email }}</span>
                </div>
                <div class="item">
                  <span class="label">Phone:</span>
                  <span class="value">{{ selectedUserValue.phone }}</span>
                </div>
                <div class="item">
                  <span class="label">Address:</span>
                  <span class="value">{{ selectedUserValue.address }}</span>
                </div>
                <div class="item">
                  <span class="label">Postcode:</span>
                  <span class="value">{{ selectedUserValue.post_code }}</span>
                </div>
                <div class="item">
                  <span class="label">Scout role:</span>
                  <span class="value">{{
                    selectedUserValue.scout_role || "Scout"
                  }}</span>
                </div>

                <b-button
                  @click="editPlayerProfileInSettings()"
                  class="main-button"
                  size="lg"
                  variant="outline-warning"
                  >Edit profile</b-button
                >

                <b-button
                  v-if="isAdmin"
                  @click="openScoutRoleModal()"
                  class="main-button"
                  size="lg"
                  variant="outline-secondary"
                  >Edit scout role</b-button
                >
              </div>
            </div>
          </div>

          <!-- Qualifications -->
          <div
            class="current-week-tab tab-content"
            v-if="selectedTab === 'qualifications-tab'"
          >
            <div class="games-info">
              <div class="form__item qualifications-data">
                <div class="numbers-dates">
                  <img src="./img/sfa-logo.jpg" alt="sfa logo" />
                  <h4>Certificates and memberships</h4>

                  <p>
                    PVG scheme membership number
                    <span
                      v-if="
                        selectedScoutQualifications.PVG_number !== null &&
                        selectedScoutQualifications.PVG_number !== undefined
                      "
                    >
                      {{ selectedScoutQualifications.PVG_number }}
                    </span>
                    <span v-else class="red-warning"
                      >Please add membership number</span
                    >
                  </p>

                  <p>
                    PVG scheme issue date
                    <span
                      v-if="selectedScoutQualifications.PVG_scheme_issue_date"
                    >
                      {{
                        formatDateForHuman(
                          selectedScoutQualifications.PVG_scheme_issue_date,
                        )
                      }}
                    </span>
                    <span v-else class="red-warning"
                      >Please add issue date</span
                    >
                  </p>

                  <p>
                    PVG scheme update due date
                    <span
                      v-if="selectedScoutQualifications.PVG_scheme_due_date"
                    >
                      {{
                        formatDateForHuman(
                          selectedScoutQualifications.PVG_scheme_due_date,
                        )
                      }}
                    </span>
                    <span v-else class="red-warning">Please add due date</span>
                  </p>

                  <p>
                    Disclosure certificate number
                    <span
                      v-if="
                        selectedScoutQualifications.disclosure_certificate_number !==
                          null &&
                        selectedScoutQualifications.disclosure_certificate_number !==
                          undefined
                      "
                    >
                      {{
                        selectedScoutQualifications.disclosure_certificate_number
                      }}
                    </span>
                    <span v-else class="red-warning"
                      >Please add certificate number</span
                    >
                  </p>
                </div>
              </div>

              <b-button
                @click="openQualificationsModal()"
                class="main-button"
                size="lg"
                variant="outline-warning"
                >Edit qualifications</b-button
              >
            </div>
          </div>

          <!-- Documents -->
          <div
            class="team-over-veiw-tab tab-content"
            v-if="selectedTab === 'documents-tab'"
          >
            <div class="tab-content">
              <div class="games-info">
                <h4>Code of Conduct</h4>

                <div class="grid-list">
                  <b-button
                    @click="gridListView = 'grid'"
                    size="lg"
                    variant="outline-secondary"
                    v-b-tooltip.hover
                    title="Grid view"
                  >
                    <i class="bi bi-grid" aria-hidden="true"></i>
                  </b-button>
                  <b-button
                    @click="gridListView = 'list'"
                    size="lg"
                    variant="outline-secondary"
                    v-b-tooltip.hover
                    title="List view"
                  >
                    <i class="bi bi-list-task" aria-hidden="true"></i>
                  </b-button>
                </div>

                <div
                  :class="
                    gridListView === 'grid'
                      ? 'signed-documents-to-pdf grid-view-wrapper'
                      : 'signed-documents-to-pdf list-view-wrapper'
                  "
                >
                  <div
                    :class="gridListView === 'grid' ? 'document' : 'list'"
                    v-for="codDocument in allCodeOfConductSignatures"
                    :key="codDocument.id"
                  >
                    <img src="../img/documentlib.svg" />
                    <h3>
                      Scout Code of Conduct -
                      {{ formatDateForHuman(codDocument.created_date) }}
                    </h3>

                    <p
                      v-if="!codDocument.head_of_academy_signature"
                      class="cod-status awaiting"
                    >
                      Awaiting Admin counter-signature
                    </p>
                    <p v-else class="cod-status complete">
                      Counter-signed by
                      {{ codDocument.head_of_academy_name }} on
                      {{
                        formatDateForHuman(
                          codDocument.head_of_academy_signed_date,
                        )
                      }}
                    </p>

                    <div class="doc-buttons">
                      <i
                        class="bi bi-trash"
                        @click="removeCodDocument(codDocument.id)"
                        aria-hidden="true"
                      ></i>
                      <a target="_blank">
                        <i
                          class="bi bi-eye"
                          @click="produceScoutCodPDF(codDocument)"
                          aria-hidden="true"
                        ></i>
                      </a>
                      <b-button
                        v-if="isAdmin && !codDocument.head_of_academy_signature"
                        size="sm"
                        variant="outline-success"
                        @click="openCounterSignModal(codDocument)"
                        >Counter-sign</b-button
                      >
                    </div>
                  </div>
                </div>

                <b-button
                  v-if="isAdmin || userData.userType === 'Scout'"
                  @click="openCodeOfConductModal()"
                  size="lg"
                  class="main-button"
                  variant="outline-success"
                >
                  <i class="bi bi-clipboard" aria-hidden="true"></i> New Code of
                  Conduct
                </b-button>

                <h4>Documents</h4>
                <div
                  :class="
                    gridListView === 'grid'
                      ? 'signed-documents-to-pdf grid-view-wrapper'
                      : 'signed-documents-to-pdf list-view-wrapper'
                  "
                >
                  <div
                    :class="gridListView === 'grid' ? 'document' : 'list'"
                    v-for="document in uploadedDocuments"
                    :key="document.id"
                    v-b-tooltip.hover
                    :title="removeNumberFromStart(document.name)"
                  >
                    <img src="../img/documentlib.svg" />
                    <h3>{{ removeNumberFromStart(document.name) }}</h3>
                    <div class="doc-buttons">
                      <i
                        class="bi bi-trash"
                        @click="
                          removeUploadedDocument(document.id, document.name)
                        "
                        aria-hidden="true"
                      ></i>
                      <a :href="getDocumentUrl(document.url)" target="_blank">
                        <i class="bi bi-eye" aria-hidden="true"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Scout Card -->
          <div
            class="current-week-tab tab-content"
            v-if="selectedTab === 'scout-card-tab'"
          >
            <div class="scout-card-tab-content">
              <div class="scout-card-actions">
                <b-button
                  class="main-button"
                  size="lg"
                  variant="outline-primary"
                  @click="openScoutCardFullscreen()"
                >
                  <i class="bi bi-fullscreen" aria-hidden="true"></i>
                  Fullscreen
                </b-button>
              </div>

              <div class="scout-card-wrapper">
                <div class="scout-card" :style="{ borderColor: tenantAccent }">
                  <div
                    class="scout-card__header"
                    :style="{ backgroundColor: tenantAccent }"
                  >
                    <TenantLogo logo-class="scout-card__club-logo" />
                    <span class="scout-card__club-name">{{ tenantName }}</span>
                  </div>
                  <div class="scout-card__body">
                    <div class="scout-card__photo">
                      <img
                        v-if="
                          selectedUserValue.userImage !== '' &&
                          selectedUserValue.userImage !== null
                        "
                        :src="getImgUrl(selectedUserValue.userImage)"
                        :alt="selectedUserValue.name"
                      />
                      <TenantLogo
                        v-else
                        logo-class="scout-card__photo-fallback"
                      />
                    </div>
                    <div class="scout-card__details">
                      <h3 class="scout-card__name">
                        {{ selectedUserValue.name }}
                      </h3>
                      <p class="scout-card__role">
                        {{ selectedUserValue.scout_role || "Scout" }}
                      </p>
                      <p class="scout-card__pvg">
                        <span class="scout-card__pvg-label">PVG No</span>
                        <span
                          v-if="selectedScoutQualifications.PVG_number"
                          class="scout-card__pvg-value"
                          >{{ selectedScoutQualifications.PVG_number }}</span
                        >
                        <span v-else class="red-warning">Not set</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template v-else>
        <div>
          <ul class="tabs">
            <li class="tab-item">
              <a
                :class="
                  selectedScoutTab === 'scouts-tab'
                    ? 'tab-link active'
                    : 'tab-link'
                "
                @click="topLevelTabChange('scouts-tab')"
                href="javascript:;"
                >Scouts</a
              >
            </li>
            <li class="tab-item">
              <a
                :class="
                  selectedScoutTab === 'information-tab'
                    ? 'tab-link active'
                    : 'tab-link'
                "
                @click="topLevelTabChange('information-tab')"
                href="javascript:;"
                >Information</a
              >
            </li>
          </ul>

          <div class="tabs-wrapper">
            <!-- Scouts grid -->
            <div class="tab-content" v-if="selectedScoutTab === 'scouts-tab'">
              <section
                class="player-profile-wrapper"
                v-if="scoutsData.length > 0"
              >
                <div
                  v-for="scout in scoutsData"
                  :value="scout.id"
                  :key="scout.id"
                  class="player-profile-details"
                  @click="selectScout(scout)"
                >
                  <div class="user-photo-info">
                    <img
                      v-if="scout.userImage !== '' && scout.userImage !== null"
                      :src="getImgUrl(scout.userImage)"
                      alt=""
                    />
                    <TenantLogo v-else logo-class="login-logo" />
                  </div>
                  <div class="user-info">
                    <h2>{{ scout.name }}</h2>
                    <p>{{ scout.scout_role || "Scout" }}</p>
                  </div>
                </div>
              </section>

              <div class="empty-state" v-else>
                <img src="../img/emptyStateIllustration.svg" />
                <p>Please select a scout to view their information</p>
              </div>
            </div>

            <!-- Information / compliance overview -->
            <div
              class="tab-content"
              v-if="selectedScoutTab === 'information-tab'"
            >
              <div class="coaches-missing-info">
                <h3>Scouts Compliance Overview</h3>
                <p>
                  Overview of PVG and disclosure details for all scouts. Items
                  highlighted in <span class="red-warning">red</span> are
                  missing or expired,
                  <span class="amber-warning">amber</span> are expiring within
                  30 days, and <span class="green-success">green</span> are
                  complete.
                </p>

                <div v-if="scoutComplianceSummary" class="compliance-summary">
                  <div class="compliance-stat">
                    <span class="stat-number">{{
                      scoutComplianceSummary.totalScouts
                    }}</span>
                    <span class="stat-label">Total Scouts</span>
                  </div>
                  <div class="compliance-stat compliance-good">
                    <span class="stat-number">{{
                      scoutComplianceSummary.fullyCompliant
                    }}</span>
                    <span class="stat-label">Fully Compliant</span>
                  </div>
                  <div class="compliance-stat compliance-warning">
                    <span class="stat-number">{{
                      scoutComplianceSummary.expiringSoon
                    }}</span>
                    <span class="stat-label">Expiring Soon</span>
                  </div>
                  <div class="compliance-stat compliance-danger">
                    <span class="stat-number">{{
                      scoutComplianceSummary.missingItems
                    }}</span>
                    <span class="stat-label">Missing Items</span>
                  </div>
                </div>

                <div
                  v-if="scoutComplianceRows.length > 0"
                  class="export-buttons"
                  style="margin-bottom: 1rem"
                >
                  <button
                    class="btn btn-outline-danger btn-sm"
                    type="button"
                    @click="exportScoutCompliancePDF()"
                  >
                    <i class="bi bi-file-earmark-pdf"></i> Export PDF
                  </button>
                  <button
                    class="btn btn-outline-success btn-sm"
                    type="button"
                    @click="exportScoutComplianceCSV()"
                  >
                    <i class="bi bi-file-earmark-spreadsheet"></i> Export CSV
                  </button>
                </div>

                <div class="table-wrapper table-scroll">
                  <div v-if="scoutComplianceRows.length > 0">
                    <vue-good-table
                      style-class="vgt-table bordered"
                      :columns="columnsScoutMissingData"
                      :rows="scoutComplianceRows"
                      :search-options="{
                        enabled: true,
                        placeholder: 'Search Scouts',
                      }"
                    >
                      <template #table-row="props">
                        <span v-if="props.column.field === 'scout_name'">
                          {{ props.row.scout_name || "Unknown" }}
                        </span>

                        <span v-else-if="props.column.field === 'scout_email'">
                          <span
                            :class="
                              props.row.scout_email
                                ? 'green-success'
                                : 'red-warning'
                            "
                          >
                            {{ props.row.scout_email || "Missing" }}
                          </span>
                        </span>

                        <span v-else-if="props.column.field === 'scout_phone'">
                          <span
                            :class="
                              props.row.scout_phone
                                ? 'green-success'
                                : 'red-warning'
                            "
                          >
                            {{ props.row.scout_phone || "Missing" }}
                          </span>
                        </span>

                        <span v-else-if="props.column.field === 'PVG_number'">
                          <span v-if="!props.row.PVG_number" class="red-warning"
                            >Missing</span
                          >
                          <span v-else class="green-success">{{
                            props.row.PVG_number
                          }}</span>
                        </span>

                        <span
                          v-else-if="
                            props.column.field === 'PVG_scheme_issue_date'
                          "
                        >
                          <span
                            v-if="!props.row.PVG_scheme_issue_date"
                            class="red-warning"
                            >Missing</span
                          >
                          <span v-else class="green-success">{{
                            formatDateForHuman(props.row.PVG_scheme_issue_date)
                          }}</span>
                        </span>

                        <span
                          v-else-if="
                            props.column.field === 'PVG_scheme_due_date'
                          "
                        >
                          <span
                            v-if="!props.row.PVG_scheme_due_date"
                            class="red-warning"
                            >Missing</span
                          >
                          <span
                            v-else
                            :class="
                              getExpiryClass(props.row.PVG_scheme_due_date)
                            "
                          >
                            {{
                              formatDateForHuman(props.row.PVG_scheme_due_date)
                            }}
                          </span>
                        </span>

                        <span
                          v-else-if="
                            props.column.field ===
                            'disclosure_certificate_number'
                          "
                        >
                          <span
                            v-if="!props.row.disclosure_certificate_number"
                            class="red-warning"
                            >Missing</span
                          >
                          <span v-else class="green-success">{{
                            props.row.disclosure_certificate_number
                          }}</span>
                        </span>

                        <span
                          v-else-if="props.column.field === 'missing_count'"
                        >
                          <span
                            :class="
                              props.row.missing_count === 0
                                ? 'green-success'
                                : 'red-warning'
                            "
                            style="font-weight: bold"
                          >
                            {{ props.row.missing_count }}
                          </span>
                        </span>
                      </template>
                    </vue-good-table>
                  </div>
                  <div v-else>
                    <div class="empty-state">
                      <img src="../img/emptyStateIllustration.svg" />
                      <p>
                        No scout data available. Scouts need to sign in and view
                        their profile.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>

    <!-- COC PDF preview -->
    <b-modal
      v-if="showMakeCodPDFModal"
      v-model="showMakeCodPDFModal"
      modal-class="modal-fullscreen"
      size="xl"
      :hide-footer="true"
    >
      <div class="player-report-content">
        <iframe id="theCodPDF_preview" src="" />
      </div>
    </b-modal>

    <!-- Scout Code of Conduct (scout + Head of Academy both sign) -->
    <b-modal
      v-if="showCodeOfConductModal"
      v-model="showCodeOfConductModal"
      modal-class="modal-fullscreen"
      size="xl"
      title="Scout Code of Conduct"
      :hide-footer="true"
    >
      <div class="player-cv-content">
        <div class="form__item">
          <div class="cod-text" v-html="renderedCodeOfConductHtml"></div>

          <div class="cod-signatures">
            <div class="cod-signature-block">
              <h4>Scout signature</h4>
              <p class="cod-signature-name">
                {{ selectedUserValue.name || "Scout" }}
              </p>
              <div class="signatureWrapper">
                <vueSignature
                  ref="scoutCOCSignature"
                  :sigOption="signatureOptions"
                  :w="'100%'"
                  :h="'260px'"
                  :disabled="false"
                ></vueSignature>
                <div class="player-game-responce">
                  <button @click="clearSignature('scoutCOCSignature')">
                    Clear
                  </button>
                </div>
              </div>
            </div>

            <div class="cod-signature-block">
              <h4>Head of Academy / Admin signature</h4>
              <p class="cod-signature-name">
                {{ userData.name || "Admin" }}
              </p>
              <div class="signatureWrapper">
                <vueSignature
                  ref="hoaCOCSignatureNew"
                  :sigOption="signatureOptions"
                  :w="'100%'"
                  :h="'260px'"
                  :disabled="false"
                ></vueSignature>
                <div class="player-game-responce">
                  <button @click="clearSignature('hoaCOCSignatureNew')">
                    Clear
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="cod-submit-row">
            <b-button
              size="lg"
              variant="outline-success"
              @click="saveScoutAndHoaSignatures()"
            >
              Save &amp; submit
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Counter-sign (admin) -->
    <b-modal
      v-if="showCounterSignModal"
      v-model="showCounterSignModal"
      modal-class="modal-fullscreen"
      size="xl"
      title="Counter-sign Scout Code of Conduct"
      :hide-footer="true"
    >
      <div class="player-cv-content">
        <div class="form__item">
          <div class="cod-text" v-html="renderedCodeOfConductHtml"></div>

          <h4>Scout signature (already signed)</h4>
          <img
            v-if="
              pendingCounterSignDoc && pendingCounterSignDoc.scout_signature
            "
            class="existing-signature"
            :src="`/images/${pendingCounterSignDoc.scout_signature}`"
            alt="Scout signature"
          />

          <h4>Head of Academy signature</h4>
          <p>Please sign below to counter-sign this document</p>
          <div class="signatureWrapper">
            <vueSignature
              ref="hoaCOCSignature"
              :sigOption="signatureOptions"
              :w="'800px'"
              :h="'400px'"
              :disabled="false"
            ></vueSignature>

            <div class="player-game-responce">
              <button @click="saveCounterSignature()">Save</button>
              <button @click="clearSignature('hoaCOCSignature')">Clear</button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Edit qualifications -->
    <b-modal
      v-if="showQualificationsModal"
      v-model="showQualificationsModal"
      size="lg"
      :title="
        qualificationsEditMode ? 'Edit qualifications' : 'Add qualifications'
      "
      :hide-footer="true"
    >
      <div class="form__item">
        <label class="form__label" for="pvg-number"
          >PVG scheme membership number</label
        >
        <b-form-input
          id="pvg-number"
          v-model="selectedScoutQualifications.PVG_number"
        ></b-form-input>
      </div>

      <div class="form__item">
        <label class="form__label" for="pvg-issue">PVG scheme issue date</label>
        <VueDatePicker
          :locale="'en-GB'"
          format="dd/MM/yyyy"
          v-model="selectedScoutQualifications.PVG_scheme_issue_date"
          name="pvg-issue"
          id="pvg-issue"
        />
      </div>

      <div class="form__item">
        <label class="form__label" for="pvg-due"
          >PVG scheme update due date</label
        >
        <VueDatePicker
          :locale="'en-GB'"
          format="dd/MM/yyyy"
          v-model="selectedScoutQualifications.PVG_scheme_due_date"
          name="pvg-due"
          id="pvg-due"
        />
      </div>

      <div class="form__item">
        <label class="form__label" for="disclosure-number"
          >Disclosure certificate number</label
        >
        <b-form-input
          id="disclosure-number"
          v-model="selectedScoutQualifications.disclosure_certificate_number"
        ></b-form-input>
      </div>

      <div class="form__item">
        <button @click="saveQualifications()" class="green-button">
          {{ qualificationsEditMode ? "Save changes" : "Add qualifications" }}
        </button>
      </div>
    </b-modal>

    <!-- Edit scout role -->
    <b-modal
      v-if="showScoutRoleModal"
      v-model="showScoutRoleModal"
      size="lg"
      title="Edit scout role"
      :hide-footer="true"
    >
      <div class="form__item">
        <label class="form__label" for="scout-role">Scout role</label>
        <b-form-input
          id="scout-role"
          v-model="scoutRoleDraft"
          placeholder="e.g. Regional Scout, Chief Scout"
        ></b-form-input>
      </div>

      <!-- Scout-list membership toggle: only meaningful when the user
           isn't already a pure Scout (their userType already keeps them
           in the list). Hidden for userType === 'Scout' to avoid a
           confusing no-op control. -->
      <div
        class="form__item"
        v-if="selectedUserValue && selectedUserValue.userType !== 'Scout'"
      >
        <label class="form__label">Scouts list membership</label>
        <b-form-checkbox v-model="isScoutDraft" switch>
          Show this {{ (selectedUserValue.userType || "user").toLowerCase() }}
          in the Scouts list
        </b-form-checkbox>
        <small class="text-muted">
          Lets an {{ selectedUserValue.userType }} also appear as a scout
          without changing their primary role.
        </small>
      </div>

      <div class="form__item">
        <button @click="saveScoutRole()" class="green-button">Save</button>
      </div>
    </b-modal>

    <!-- Fullscreen scout card (for showing on a phone) -->
    <div
      v-if="showScoutCardFullscreen"
      class="scout-card-fullscreen"
      :style="{ backgroundColor: tenantAccent }"
      @click="closeScoutCardFullscreen()"
    >
      <button
        class="scout-card-fullscreen__close"
        @click.stop="closeScoutCardFullscreen()"
        aria-label="Close fullscreen"
      >
        <i class="bi bi-x-lg" aria-hidden="true"></i>
      </button>
      <div
        class="scout-card scout-card--fullscreen"
        :style="{ borderColor: '#fff' }"
        @click.stop
      >
        <div
          class="scout-card__header"
          :style="{ backgroundColor: tenantAccent }"
        >
          <TenantLogo logo-class="scout-card__club-logo" />
          <span class="scout-card__club-name">{{ tenantName }}</span>
        </div>
        <div class="scout-card__body">
          <div class="scout-card__photo">
            <img
              v-if="
                selectedUserValue.userImage !== '' &&
                selectedUserValue.userImage !== null
              "
              :src="getImgUrl(selectedUserValue.userImage)"
              :alt="selectedUserValue.name"
            />
            <TenantLogo v-else logo-class="scout-card__photo-fallback" />
          </div>
          <div class="scout-card__details">
            <h3 class="scout-card__name">{{ selectedUserValue.name }}</h3>
            <p class="scout-card__role">
              {{ selectedUserValue.scout_role || "Scout" }}
            </p>
            <p class="scout-card__pvg">
              <span class="scout-card__pvg-label">PVG No</span>
              <span
                v-if="selectedScoutQualifications.PVG_number"
                class="scout-card__pvg-value"
                >{{ selectedScoutQualifications.PVG_number }}</span
              >
              <span v-else class="red-warning">Not set</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Hidden signature images for PDF -->
    <template v-if="allCodeOfConductSignatures.length > 0">
      <template
        v-for="sig in allCodeOfConductSignatures"
        :key="`${sig.id}-codeOfConductSignatures`"
      >
        <img
          v-if="sig.scout_signature"
          alt=""
          class="visually-hidden"
          :id="`scout-sig-${sig.id}`"
          :src="`/images/${sig.scout_signature}`"
        />
        <img
          v-if="sig.head_of_academy_signature"
          alt=""
          class="visually-hidden"
          :id="`hoa-sig-${sig.id}`"
          :src="`/images/${sig.head_of_academy_signature}`"
        />
      </template>
    </template>
    <img alt="" class="visually-hidden" id="png-logo" />
  </div>
</template>

<script>
import SpinnerLoader from "../../components/LoadingSpinning";
import AppTemplate from "../layouts/App";
import { mapGetters } from "vuex";
import { USER_POPULATE } from "@/store/actions/user.js";
import { Users } from "@/services/user-service.js";
import { Coaches } from "@/services/coaches-service.js";
import { Documents } from "@/services/documents-service.js";
import vueSignature from "vue-signature";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import moment from "moment";
import JsPDF from "jspdf";
import TenantLogo from "@/components/TenantLogo/index.vue";
import tenantConfig, { getTenantName } from "@/config/tenant.js";

export default {
  name: "Scouts",
  components: {
    AppTemplate,
    SpinnerLoader,
    vueSignature,
    VueDatePicker,
    TenantLogo,
  },
  data() {
    return {
      loadingStuff: false,
      selectedTab: "contact-tab",
      selectedScoutTab: "scouts-tab",
      gridListView: "grid",
      allScoutsMissingData: [],
      columnsScoutMissingData: [
        { label: "Name", field: "scout_name", sortable: true },
        { label: "Email", field: "scout_email", sortable: true },
        { label: "Phone", field: "scout_phone", sortable: true },
        { label: "PVG Number", field: "PVG_number", sortable: true },
        {
          label: "PVG Issue Date",
          field: "PVG_scheme_issue_date",
          sortable: true,
        },
        {
          label: "PVG Due Date",
          field: "PVG_scheme_due_date",
          sortable: true,
        },
        {
          label: "Disclosure",
          field: "disclosure_certificate_number",
          sortable: true,
        },
        {
          label: "Missing",
          field: "missing_count",
          sortable: true,
          type: "number",
        },
      ],
      signatureOptions: {
        penColor: "rgb(0, 0, 0)",
        backgroundColor: "rgb(255,255,255)",
      },
      userData: {
        name: "",
        userType: "",
      },
      userHeaderData: {
        name: "",
        userType: "",
      },
      scoutsData: [],
      selectedUserValue: "",
      selectedScoutQualifications: {
        PVG_number: null,
        PVG_scheme_issue_date: null,
        PVG_scheme_due_date: null,
        disclosure_certificate_number: null,
      },
      qualificationsEditMode: false,
      codeOfConductData: {},
      allCodeOfConductSignatures: [],
      uploadedDocuments: [],
      pendingCounterSignDoc: null,
      scoutRoleDraft: "",
      isScoutDraft: false,
      showMakeCodPDFModal: false,
      showCodeOfConductModal: false,
      showCounterSignModal: false,
      showQualificationsModal: false,
      showScoutRoleModal: false,
      showScoutCardFullscreen: false,
    };
  },
  computed: {
    ...mapGetters(["getProfile"]),
    isAdmin() {
      return this.userData.userType === "Admin";
    },
    tenantName() {
      return getTenantName();
    },
    tenantAccent() {
      return tenantConfig?.manifest?.theme_color || "#1a1a1a";
    },
    renderedCodeOfConductHtml() {
      const text = this.codeOfConductData?.text || "";
      return this.renderClubTokens(text).replace(/\n/g, "<br />");
    },
    scoutComplianceRows() {
      // Merge qualifications data with the scout list (so scouts without
      // qualifications rows still appear, flagged as missing).
      return this.scoutsData.map((scout) => {
        const qual =
          this.allScoutsMissingData.find((q) => q.coach_id === scout.id) || {};
        const row = {
          scout_id: scout.id,
          scout_name: scout.name || qual.coach_name || "Unknown",
          scout_email: scout.email || qual.coach_email || "",
          scout_phone: scout.phone || qual.coach_phone || "",
          PVG_number: qual.PVG_number || null,
          PVG_scheme_issue_date: qual.PVG_scheme_issue_date || null,
          PVG_scheme_due_date: qual.PVG_scheme_due_date || null,
          disclosure_certificate_number:
            qual.disclosure_certificate_number || null,
        };
        row.missing_count = this.getScoutMissingCount(row);
        return row;
      });
    },
    scoutComplianceSummary() {
      const rows = this.scoutComplianceRows;
      if (rows.length === 0) return null;

      let expiringSoon = 0;
      let totalMissing = 0;
      let fullyCompliant = 0;

      rows.forEach((row) => {
        if (row.missing_count === 0) fullyCompliant++;
        totalMissing += row.missing_count;
        if (this.isExpiringSoon(row.PVG_scheme_due_date)) expiringSoon++;
      });

      return {
        totalScouts: rows.length,
        fullyCompliant,
        expiringSoon,
        missingItems: totalMissing,
      };
    },
  },
  created() {
    this.loadingStuff = true;
    const clientId = JSON.parse(localStorage.getItem("the_w_selectedClientId"));
    this.getUserByIdForHeader(clientId);
    this.getUserById(clientId).then((ready) => {
      if (!ready) {
        this.loadingStuff = false;
        return;
      }

      if (this.userData.userType === "Scout") {
        this.getSelfScout();
      } else if (
        this.userData.userType === "Admin" ||
        this.userData.userType === "Coach"
      ) {
        this.getAllScouts();
      }
      this.loadingStuff = false;
    });
  },
  methods: {
    // Serve documents via the PHP endpoint (resolves the uploads/documents
    // folder + legacy root). Mirrors documents/index.vue.
    getDocumentUrl(filename) {
      if (!filename) return "";
      if (window.location.href.indexOf("8080") > -1) {
        return `http://www.localhost:8888/serve-document.php?file=${encodeURIComponent(filename)}`;
      }
      return `/personal-training-BE/serve-document.php?file=${encodeURIComponent(filename)}`;
    },
    renderClubTokens(text) {
      return (text || "").replaceAll("{{clubName}}", this.tenantName);
    },
    tabChange(tab) {
      this.selectedTab = tab;
      if (tab === "documents-tab") {
        this.getCodeOfConductData();
        this.getCodeOfConductSignatures();
      }
    },
    openScoutCardFullscreen() {
      this.showScoutCardFullscreen = true;
    },
    closeScoutCardFullscreen() {
      this.showScoutCardFullscreen = false;
    },
    selectScout(scout) {
      this.selectedUserValue = scout;
      this.getScoutQualifications();
      this.getDocumentUploadsByUserId();
      this.getCodeOfConductData();
      this.getCodeOfConductSignatures();
      this.prepareLogoForPdf();
    },
    prepareLogoForPdf() {
      const mainLogo = document.getElementById("main-logo");
      if (!mainLogo) return;
      this.base64SvgToBase64Png(mainLogo.src, 200).then((pngSrc) => {
        const target = document.getElementById("png-logo");
        if (target && pngSrc) target.src = pngSrc;
      });
    },
    base64SvgToBase64Png(originalBase64, width) {
      return new Promise((resolve) => {
        const img = document.createElement("img");
        img.onload = function () {
          document.body.appendChild(img);
          const canvas = document.createElement("canvas");
          const ratio = img.clientWidth / img.clientHeight || 1;
          document.body.removeChild(img);
          canvas.width = width;
          canvas.height = width / ratio;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          try {
            resolve(canvas.toDataURL("image/png"));
          } catch (e) {
            resolve(null);
          }
        };
        img.onerror = () => resolve(null);
        img.src = originalBase64;
      });
    },
    getImgUrl(pic) {
      return pic !== undefined && pic !== "" ? `/images/${pic}` : "";
    },
    formatDateForHuman(date) {
      return date !== undefined && moment(date).isValid()
        ? moment(date).format("MMMM Do YYYY")
        : "";
    },
    formatMatchDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    removeNumberFromStart(documentName) {
      return documentName.substring(documentName.indexOf("_") + 1);
    },
    editPlayerProfileInSettings() {
      this.$router.push("/settings").catch(() => {});
    },

    async getUserById(clientId) {
      const userData = { clientId, action: "getUserByID" };
      const response = await Users.find(userData).catch((err) =>
        console.log(err),
      );
      if (response?.data?.length > 0) {
        this.userData = response.data[0];
        const fresh = response.data[0];
        this.$store.dispatch(USER_POPULATE, { userData: fresh });
        return true;
      }
      return false;
    },
    async getUserByIdForHeader(clientId) {
      const userData = { clientId, action: "getUserByID" };
      const response = await Users.find(userData).catch((err) =>
        console.log(err),
      );
      if (response?.data?.length > 0) {
        this.userHeaderData = response.data[0];
      }
    },
    async getSelfScout() {
      const response = await Coaches.find({
        action: "getScoutsById",
        id: this.userData.id,
      }).catch((err) => console.log(err));
      if (response?.data?.length > 0) {
        this.scoutsData = response.data;
      }
    },
    async getAllScouts() {
      const response = await Coaches.find({
        action: "getAllScoutsByClubId",
        clubId: this.userData.clubId,
      }).catch((err) => console.log(err));
      if (response?.data?.length > 0) {
        this.scoutsData = response.data;
        this.getAllScoutsWithMissingData();
      }
    },
    async getAllScoutsWithMissingData() {
      const listOfScoutIds = this.scoutsData.map((s) => s.id);
      if (listOfScoutIds.length === 0) return;

      try {
        const response = await Coaches.find({
          action: "getSelectedCoachesQualificationsById",
          listOfCoachIds: listOfScoutIds,
        });
        if (response && response.status === 200) {
          this.allScoutsMissingData = Array.isArray(response.data)
            ? response.data
            : [];
        }
      } catch (error) {
        console.error("Failed to load scout compliance data:", error);
      }
    },
    getScoutMissingCount(row) {
      let count = 0;
      if (!row.PVG_number) count++;
      if (!row.PVG_scheme_issue_date) count++;
      if (!row.PVG_scheme_due_date) count++;
      if (!row.disclosure_certificate_number) count++;
      if (!row.scout_email) count++;
      if (!row.scout_phone) count++;
      if (this.isExpired(row.PVG_scheme_due_date)) count++;
      return count;
    },
    isExpired(dateStr) {
      if (!dateStr) return false;
      return moment(dateStr).isBefore(moment(), "day");
    },
    isExpiringSoon(dateStr) {
      if (!dateStr) return false;
      const due = moment(dateStr);
      return due.isAfter(moment()) && due.diff(moment(), "days") <= 30;
    },
    getExpiryClass(dateStr) {
      if (this.isExpired(dateStr)) return "red-warning";
      if (this.isExpiringSoon(dateStr)) return "amber-warning";
      return "green-success";
    },
    topLevelTabChange(tab) {
      this.selectedScoutTab = tab;
      if (tab === "information-tab" && this.scoutsData.length > 0) {
        this.getAllScoutsWithMissingData();
      }
    },
    exportScoutCompliancePDF() {
      const pdf = new JsPDF("l", "mm", "a4");
      const rows = this.scoutComplianceRows;
      const pageWidth = 297;
      const margin = 10;

      pdf.setFontSize(16).setFont(undefined, "bold");
      pdf.text("Scouts Compliance Report", margin, 12);
      pdf.setFontSize(10).setFont(undefined, "normal");
      pdf.text("Generated: " + moment().format("MMMM Do YYYY"), margin, 19);

      const summary = this.scoutComplianceSummary || {
        totalScouts: 0,
        fullyCompliant: 0,
        expiringSoon: 0,
        missingItems: 0,
      };
      pdf.text(
        `Total: ${summary.totalScouts} | Fully Compliant: ${summary.fullyCompliant} | Expiring Soon: ${summary.expiringSoon} | Missing Items: ${summary.missingItems}`,
        margin,
        29,
      );

      let yPos = 38;
      const headers = [
        "Name",
        "Email",
        "Phone",
        "PVG Number",
        "PVG Issue",
        "PVG Due",
        "Disclosure",
        "Missing",
      ];
      const colWidths = [40, 50, 30, 30, 30, 30, 35, 20];

      pdf.setFillColor(0, 85, 150);
      pdf.rect(margin, yPos - 5, pageWidth - margin * 2, 8, "F");
      pdf.setTextColor(255, 255, 255);
      pdf.setFontSize(8).setFont(undefined, "bold");

      let xPos = margin;
      headers.forEach((h, i) => {
        pdf.text(h, xPos + 1, yPos);
        xPos += colWidths[i];
      });

      yPos += 6;
      pdf.setTextColor(51, 51, 51);
      pdf.setFontSize(8).setFont(undefined, "normal");

      rows.forEach((row, idx) => {
        if (yPos > 190) {
          pdf.addPage();
          yPos = 15;
        }

        if (idx % 2 === 0) {
          pdf.setFillColor(245, 245, 245);
          pdf.rect(margin, yPos - 4, pageWidth - margin * 2, 6, "F");
        }

        xPos = margin;
        const values = [
          String(row.scout_name || "Unknown"),
          String(row.scout_email || "Missing"),
          String(row.scout_phone || "Missing"),
          String(row.PVG_number || "Missing"),
          row.PVG_scheme_issue_date
            ? this.formatDateForHuman(row.PVG_scheme_issue_date)
            : "Missing",
          row.PVG_scheme_due_date
            ? this.formatDateForHuman(row.PVG_scheme_due_date)
            : "Missing",
          String(row.disclosure_certificate_number || "Missing"),
          String(row.missing_count),
        ];

        values.forEach((val, i) => {
          const maxChars = Math.floor(colWidths[i] / 2);
          const truncated =
            val.length > maxChars ? val.substring(0, maxChars) + "..." : val;
          pdf.text(truncated, xPos + 1, yPos);
          xPos += colWidths[i];
        });

        yPos += 6;
      });

      pdf.save(`scouts-compliance-${moment().format("YYYY-MM-DD")}.pdf`);
    },
    exportScoutComplianceCSV() {
      const rows = this.scoutComplianceRows;
      const headers = [
        "Name",
        "Email",
        "Phone",
        "PVG Number",
        "PVG Issue Date",
        "PVG Due Date",
        "Disclosure Number",
        "Missing Items Count",
      ];

      const csvRows = [headers.join(",")];
      rows.forEach((row) => {
        const values = [
          row.scout_name || "",
          row.scout_email || "",
          row.scout_phone || "",
          row.PVG_number || "",
          row.PVG_scheme_issue_date
            ? this.formatDateForHuman(row.PVG_scheme_issue_date)
            : "",
          row.PVG_scheme_due_date
            ? this.formatDateForHuman(row.PVG_scheme_due_date)
            : "",
          row.disclosure_certificate_number || "",
          row.missing_count,
        ].map((v) => `"${String(v).replace(/"/g, '""')}"`);
        csvRows.push(values.join(","));
      });

      const blob = new Blob([csvRows.join("\n")], {
        type: "text/csv;charset=utf-8;",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `scouts-compliance-${moment().format("YYYY-MM-DD")}.csv`;
      link.click();
      URL.revokeObjectURL(link.href);
    },

    async getScoutQualifications() {
      const response = await Coaches.find({
        coach_id: this.selectedUserValue.id,
        clubId: this.selectedUserValue.clubId,
        action: "getCoachesQualificationsById",
      }).catch((err) => console.log(err));

      if (response?.data && typeof response.data !== "string") {
        this.selectedScoutQualifications = {
          PVG_number: response.data.PVG_number ?? null,
          PVG_scheme_issue_date: response.data.PVG_scheme_issue_date ?? null,
          PVG_scheme_due_date: response.data.PVG_scheme_due_date ?? null,
          disclosure_certificate_number:
            response.data.disclosure_certificate_number ?? null,
        };
      } else {
        this.selectedScoutQualifications = {
          PVG_number: null,
          PVG_scheme_issue_date: null,
          PVG_scheme_due_date: null,
          disclosure_certificate_number: null,
        };
      }
    },
    openQualificationsModal() {
      this.qualificationsEditMode =
        this.selectedScoutQualifications.PVG_number !== null ||
        this.selectedScoutQualifications.disclosure_certificate_number !== null;
      this.showQualificationsModal = true;
    },
    async saveQualifications() {
      const dateFields = ["PVG_scheme_issue_date", "PVG_scheme_due_date"];
      const payload = { ...this.selectedScoutQualifications };
      dateFields.forEach((field) => {
        if (payload[field]) {
          payload[field] = this.formatMatchDate(payload[field]);
        }
      });

      const action = this.qualificationsEditMode
        ? "editCoachesQualifications"
        : "addCoachQualifications";

      const response = await Coaches.find({
        ...payload,
        coach_id: this.selectedUserValue.id,
        clubId: this.selectedUserValue.clubId,
        action,
      }).catch((err) => console.log(err));

      if (response?.status === 200) {
        this.showQualificationsModal = false;
        this.getScoutQualifications();
        this.$toast.info("Qualifications saved.", {
          title: "Saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },

    openScoutRoleModal() {
      this.scoutRoleDraft = this.selectedUserValue.scout_role || "";
      // Coerce numeric / string flag from API to boolean for the switch.
      this.isScoutDraft = Number(this.selectedUserValue.is_scout) === 1;
      this.showScoutRoleModal = true;
    },
    async saveScoutRole() {
      // Persist scout_role and is_scout in parallel. Either one or both
      // may have changed; both endpoints are no-ops if the value is the
      // same as what's already stored.
      const wasInList =
        Number(this.selectedUserValue.is_scout) === 1 ||
        this.selectedUserValue.userType === "Scout";
      const willBeInList =
        this.isScoutDraft || this.selectedUserValue.userType === "Scout";
      const newIsScout = this.isScoutDraft ? 1 : 0;

      const [roleResp, scoutResp] = await Promise.all([
        Coaches.find({
          action: "saveScoutRole",
          id: this.selectedUserValue.id,
          scout_role: this.scoutRoleDraft,
        }).catch((err) => {
          console.log(err);
          return null;
        }),
        Coaches.find({
          action: "saveIsScout",
          id: this.selectedUserValue.id,
          is_scout: newIsScout,
        }).catch((err) => {
          console.log(err);
          return null;
        }),
      ]);

      if (roleResp?.status === 200 && scoutResp?.status === 200) {
        this.selectedUserValue = {
          ...this.selectedUserValue,
          scout_role: this.scoutRoleDraft,
          is_scout: newIsScout,
        };

        if (wasInList && !willBeInList) {
          // They've been removed from the list — drop them locally so
          // the grid updates without a round-trip.
          this.scoutsData = this.scoutsData.filter(
            (s) => s.id !== this.selectedUserValue.id,
          );
        } else {
          this.scoutsData = this.scoutsData.map((s) =>
            s.id === this.selectedUserValue.id
              ? {
                  ...s,
                  scout_role: this.scoutRoleDraft,
                  is_scout: newIsScout,
                }
              : s,
          );
        }

        this.showScoutRoleModal = false;
        this.$toast.info("Scout details saved.", {
          title: "Saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },

    async getCodeOfConductData() {
      if (!this.selectedUserValue) return;
      const response = await Documents.find({
        action: "getCodeOfConductData",
        clubId: this.selectedUserValue.clubId,
        document_type: "scout",
      }).catch((err) => console.log(err));

      if (response?.status === 200 && response.data) {
        this.codeOfConductData = response.data;
      }
    },
    async getCodeOfConductSignatures() {
      if (!this.selectedUserValue) return;
      const response = await Documents.find({
        action: "getCodeOfConductSignatures",
        coach_id: this.selectedUserValue.id,
        document_type: "scout",
      }).catch((err) => console.log(err));

      if (response?.status === 200 && typeof response.data !== "boolean") {
        this.allCodeOfConductSignatures = response.data || [];
      }
    },
    async getDocumentUploadsByUserId() {
      const response = await Documents.find({
        action: "getDocumentUploadsByUserId",
        user_id: this.selectedUserValue.id,
      }).catch((err) => console.log(err));

      if (response?.status === 200) {
        this.uploadedDocuments = response.data;
      }
    },
    async removeUploadedDocument(id, name) {
      const response = await Documents.find({
        action: "removeDocumentUpload",
        id,
        name,
      }).catch((err) => console.log(err));

      if (response?.status === 200) {
        this.getDocumentUploadsByUserId();
        this.$toast.info("Document deleted.", {
          title: "Deleted",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    async removeCodDocument(id) {
      const response = await Documents.find({
        action: "removeCodeOfConductSignature",
        id,
      }).catch((err) => console.log(err));

      if (response?.status === 200) {
        this.getCodeOfConductSignatures();
        this.$toast.info("Code of Conduct deleted.", {
          title: "Deleted",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },

    openCodeOfConductModal() {
      this.showCodeOfConductModal = true;
    },
    clearSignature(refName) {
      if (this.$refs[refName]) this.$refs[refName].clear();
    },
    async saveScoutAndHoaSignatures() {
      const scoutRef = this.$refs.scoutCOCSignature;
      const hoaRef = this.$refs.hoaCOCSignatureNew;
      if (!scoutRef || !hoaRef) return;

      if (scoutRef.isEmpty() || hoaRef.isEmpty()) {
        this.$toast.info(
          "Both the scout and Head of Academy need to sign before submitting.",
          {
            title: "Missing signature",
            toaster: "b-toaster-bottom-right",
            solid: true,
            appendToast: true,
            variant: "warning",
          },
        );
        return;
      }

      const scoutJpeg = scoutRef.save("image/jpeg");
      const hoaJpeg = hoaRef.save("image/jpeg");

      const response = await Documents.find({
        action: "saveScoutCocBothSignatures",
        coach_id: this.selectedUserValue.id,
        head_of_academy_user_id: this.userData.id,
        created_date: moment().format("YYYY-MM-DD HH:mm:ss"),
        scout_imageFile: scoutJpeg,
        hoa_imageFile: hoaJpeg,
      }).catch((err) => console.log(err));

      if (response?.status === 200) {
        this.showCodeOfConductModal = false;
        this.getCodeOfConductSignatures();
        this.$toast.info("Code of Conduct saved.", {
          title: "Saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    openCounterSignModal(codDocument) {
      this.pendingCounterSignDoc = codDocument;
      this.showCounterSignModal = true;
    },
    async saveCounterSignature() {
      const ref = this.$refs.hoaCOCSignature;
      if (!ref || !this.pendingCounterSignDoc) return;
      const jpeg = ref.save("image/jpeg");

      const response = await Documents.find({
        fileName: "hoaCOCSignature",
        imageFile: jpeg,
        coach_id: this.selectedUserValue.id,
        cod_signature_id: this.pendingCounterSignDoc.id,
        head_of_academy_user_id: this.userData.id,
        signer_role: "head_of_academy",
        action: "saveCodeOfConductSignatureCall",
        created_date: moment().format("YYYY-MM-DD HH:mm:ss"),
      }).catch((err) => console.log(err));

      if (response?.status === 200) {
        this.showCounterSignModal = false;
        this.pendingCounterSignDoc = null;
        this.getCodeOfConductSignatures();
        this.$toast.info("Counter-signature saved.", {
          title: "Saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },

    produceScoutCodPDF(document) {
      this.showMakeCodPDFModal = true;
      setTimeout(() => {
        const pdf = this.makeScoutCodPDF(document);
        pdf.previewLink.src = pdf.pdfData.output("datauristring");
      }, 500);
    },
    newPageCheck(currentY, pdf) {
      if (currentY >= 260) {
        pdf.addPage();
        return 20;
      }
      return currentY;
    },
    makeScoutCodPDF(codData) {
      const previewContainer = document.getElementById("theCodPDF_preview");
      const pdf = new JsPDF("p", "mm", "a4");

      const logo = document.getElementById("png-logo");
      if (logo && logo.src) {
        try {
          pdf.addImage(logo, "PNG", 5, 4, 20, 20);
        } catch (e) {
          // logo missing/invalid — skip
        }
      }

      pdf.setFontSize(14).setFont(undefined, "bold");
      pdf.text(30, 14, "SCOUT CODE OF CONDUCT");

      const stripHtml = (s) => (s || "").replace(/<[^>]*>/g, "");
      const bodyText = this.renderClubTokens(
        stripHtml(this.codeOfConductData?.text || ""),
      );

      pdf.setFontSize(10).setFont(undefined, "normal");
      let y = 32;
      bodyText.split(/\n+/).forEach((paragraph) => {
        if (!paragraph.trim()) return;
        const lines = pdf.splitTextToSize(paragraph, 190);
        const dim = pdf.getTextDimensions(lines);
        pdf.text(5, y, lines, { maxWidth: 190 });
        y += dim.h + 4;
        y = this.newPageCheck(y, pdf);
      });

      // Scout signature block
      y = this.newPageCheck(y + 6, pdf);
      pdf.setFont(undefined, "bold");
      pdf.text(5, y, `Signed by scout: ${this.selectedUserValue.name || ""}`);
      pdf.setFont(undefined, "normal");
      y += 6;
      pdf.text(5, y, `Date: ${this.formatDateForHuman(codData.created_date)}`);
      y += 4;

      const scoutSigImg = document.getElementById(`scout-sig-${codData.id}`);
      if (scoutSigImg && scoutSigImg.src) {
        try {
          pdf.addImage(scoutSigImg, "JPEG", 5, y, 100, 40);
        } catch (e) {
          // signature image not loaded
        }
      }
      y += 44;
      y = this.newPageCheck(y, pdf);

      // Head of Academy signature block
      pdf.setFont(undefined, "bold");
      if (codData.head_of_academy_signature) {
        pdf.text(
          5,
          y,
          `Counter-signed by Head of Academy: ${codData.head_of_academy_name || ""}`,
        );
        pdf.setFont(undefined, "normal");
        y += 6;
        pdf.text(
          5,
          y,
          `Date: ${this.formatDateForHuman(codData.head_of_academy_signed_date)}`,
        );
        y += 4;

        const hoaSigImg = document.getElementById(`hoa-sig-${codData.id}`);
        if (hoaSigImg && hoaSigImg.src) {
          try {
            pdf.addImage(hoaSigImg, "JPEG", 5, y, 100, 40);
          } catch (e) {
            // not loaded
          }
        }
      } else {
        pdf.text(5, y, "Awaiting counter-signature from Head of Academy");
      }

      return { pdfData: pdf, previewLink: previewContainer };
    },
  },
};
</script>

<style lang="scss" scoped>
.tabs-wrapper {
  .tab-content {
    overflow: auto;
  }
}

.coaches-missing-info {
  padding: 2rem;

  .compliance-summary {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    margin-bottom: 1.5rem;

    .compliance-stat {
      background: #f8f9fa;
      border-radius: 8px;
      padding: 1rem 1.5rem;
      text-align: center;
      min-width: 120px;
      border-left: 4px solid #6c757d;

      .stat-number {
        display: block;
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 1.2;
      }

      .stat-label {
        display: block;
        font-size: 0.8rem;
        color: #6c757d;
      }

      &.compliance-good {
        border-left-color: #28a745;
        .stat-number {
          color: #28a745;
        }
      }

      &.compliance-warning {
        border-left-color: #ffc107;
        .stat-number {
          color: #e0a800;
        }
      }

      &.compliance-danger {
        border-left-color: #dc3545;
        .stat-number {
          color: #dc3545;
        }
      }
    }
  }

  .export-buttons {
    display: flex;
    gap: 0.5rem;

    .btn {
      display: flex;
      align-items: center;
      gap: 0.3rem;
    }
  }

  .amber-warning {
    color: #e0a800;
    font-weight: 600;
  }
}

.personal-info {
  .main-button {
    margin-right: 0.75rem;
    margin-top: 1rem;
  }

  .user-photo-info {
    width: 8rem;
    height: 8rem;
    border-radius: 50%;
    overflow: hidden;
    margin-bottom: 1rem;
    background: #f2f5f7;
    display: flex;
    align-items: center;
    justify-content: center;

    // Real user photo fills the circle.
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    // Tenant logo fallback stays smaller so it doesn't overflow.
    :deep(.login-logo) {
      width: auto;
      height: auto;
      max-width: 65%;
      max-height: 65%;
      object-fit: contain;
    }
  }
}

.qualifications-data {
  .numbers-dates {
    background: #fff;
    border: 1px solid #dde3ea;
    border-radius: 8px;
    padding: 1.5rem;
    margin-bottom: 1.5rem;

    img {
      width: 3rem;
      margin-bottom: 0.5rem;
    }

    h4 {
      margin-bottom: 1rem;
    }

    p {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 1rem;
      padding: 0.5rem 0;
      border-bottom: 1px solid #eef1f4;
      margin: 0;

      &:last-of-type {
        border-bottom: none;
      }

      span:not(.red-warning) {
        font-weight: 600;
      }
    }
  }
}

.grid-list {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1.5rem;
  border-bottom: 1px dashed #c3cdd5;
  padding-bottom: 0.5rem;

  .btn-outline-secondary {
    border: none !important;
  }
}

.list-view-wrapper {
  display: block;
}

.grid-view-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.document {
  max-width: 16rem;
  text-align: center;
  padding: 1rem;
  margin: 1rem 0;
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(138, 138, 138, 0.3);
  border: 1px solid transparent;

  &:hover,
  &:focus {
    border-color: #a1152f;
  }

  h3 {
    margin-top: 1rem;
    font-size: 1rem;
    text-transform: inherit;
  }

  img {
    width: 40%;
  }
}

.list {
  display: flex;
  gap: 1rem;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #c3cdd5;

  img {
    width: 2rem;
  }

  h3 {
    margin: 0;
    text-transform: none;
  }

  .doc-buttons {
    margin: 0;
  }
}

.doc-buttons {
  display: flex;
  gap: 0.75rem;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;

  i.bi {
    border: 1px solid #c3cdd5;
    padding: 0.3rem 0.5rem;
    border-radius: 4px;
    font-size: 1.1rem;
    cursor: pointer;

    &:hover,
    &:focus {
      background: #eaeff3;
    }
  }
}

.player-report-content {
  margin-top: 1rem;
  width: 100%;
  height: 50rem;

  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
}

.cod-status {
  font-size: 0.85rem;
  margin: 0.5rem 0 0;

  &.awaiting {
    color: #c07a00;
    font-weight: 600;
  }

  &.complete {
    color: #2b7a2b;
  }
}

.existing-signature {
  display: block;
  max-width: 300px;
  border: 1px solid #c3cdd5;
  margin-bottom: 1rem;
}

.cod-text {
  white-space: pre-wrap;
  margin-bottom: 1.5rem;
  line-height: 1.6;
}

.cod-signatures {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-top: 1rem;
}

.cod-signature-block {
  border: 1px solid #dde3ea;
  border-radius: 8px;
  padding: 1rem;
  background: #fff;

  h4 {
    margin-top: 0;
  }

  .signatureWrapper {
    width: 100%;
  }

  :deep(canvas) {
    width: 100% !important;
    height: 260px !important;
    border: 1px solid #c3cdd5;
    border-radius: 4px;
  }
}

.cod-signature-name {
  font-weight: 600;
  color: #555;
  margin: 0 0 0.75rem;
}

.cod-submit-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 1.5rem;
}

@media (max-width: 768px) {
  .cod-signatures {
    grid-template-columns: 1fr;
  }
}

.scout-card-tab-content {
  padding: 1.5rem;
}

.scout-card-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1rem;
}

.scout-card-wrapper {
  display: flex;
  justify-content: center;
  padding: 1rem 0 3rem;
}

.scout-card {
  width: 100%;
  max-width: 760px;
  border: 4px solid;
  border-radius: 20px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);

  &__header {
    display: flex;
    align-items: center;
    gap: 1.25rem;
    padding: 1.25rem 1.75rem;
    color: #fff;
  }

  :deep(.scout-card__club-logo) {
    height: 64px;
    width: auto;
  }

  &__club-name {
    font-weight: 800;
    font-size: 1.5rem;
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }

  &__body {
    display: flex;
    gap: 2.5rem;
    padding: 2.5rem;
    align-items: center;
  }

  &__photo {
    flex: 0 0 220px;
    width: 220px;
    height: 220px;
    border-radius: 50%;
    overflow: hidden;
    background: #f2f4f7;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 4px solid #fff;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  :deep(.scout-card__photo-fallback) {
    width: 70%;
    opacity: 0.5;
  }

  &__details {
    flex: 1;
    min-width: 0;
  }

  &__name {
    margin: 0 0 0.5rem 0;
    font-size: 2.25rem;
    line-height: 1.1;
    text-transform: none;
    font-weight: 800;
  }

  &__role {
    margin: 0 0 1.5rem 0;
    font-weight: 600;
    color: #555;
    font-size: 1.35rem;
  }

  &__pvg {
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }

  &__pvg-label {
    font-size: 0.75rem;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #888;
  }

  &__pvg-value {
    font-size: 1.5rem;
    font-weight: 700;
    color: #222;
    font-variant-numeric: tabular-nums;
  }
}

// Fullscreen card — phone-friendly, stacked layout
.scout-card-fullscreen {
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  animation: scoutCardFadeIn 150ms ease-out;

  &__close {
    position: absolute;
    top: 1rem;
    right: 1rem;
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    border: none;
    background: rgba(255, 255, 255, 0.95);
    color: #111;
    font-size: 1.1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);

    &:hover {
      background: #fff;
    }
  }

  .scout-card--fullscreen {
    max-width: 960px;
    width: 100%;

    .scout-card__body {
      // Keep the two-column layout (photo left, details right) regardless of
      // viewport — override the mobile stack rule below.
      flex-direction: row;
      text-align: left;
      align-items: center;
      gap: 2.5rem;
      padding: 2.5rem;
    }

    .scout-card__photo {
      flex: 0 0 260px;
      width: 260px;
      height: 260px;
    }

    .scout-card__details {
      flex: 1;
    }

    .scout-card__name {
      font-size: 2.75rem;
    }

    .scout-card__role {
      font-size: 1.5rem;
      margin-bottom: 1.25rem;
    }

    .scout-card__pvg {
      align-items: flex-start;
    }

    .scout-card__pvg-value {
      font-size: 1.85rem;
    }
  }
}

@keyframes scoutCardFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (max-width: 640px) {
  .scout-card:not(.scout-card--fullscreen) .scout-card__body {
    flex-direction: column;
    text-align: center;
    gap: 1.5rem;
    padding: 1.5rem;
  }

  .scout-card:not(.scout-card--fullscreen) .scout-card__photo {
    flex: 0 0 180px;
    width: 180px;
    height: 180px;
  }

  .scout-card:not(.scout-card--fullscreen) .scout-card__name {
    font-size: 1.75rem;
  }

  .scout-card:not(.scout-card--fullscreen) .scout-card__pvg {
    align-items: center;
  }

  // Fullscreen keeps two-col layout, but scales down to fit phone screens.
  .scout-card--fullscreen .scout-card__body {
    gap: 1.25rem;
    padding: 1.25rem;
  }

  .scout-card--fullscreen .scout-card__photo {
    flex: 0 0 130px;
    width: 130px;
    height: 130px;
  }

  .scout-card--fullscreen .scout-card__name {
    font-size: 1.6rem;
  }

  .scout-card--fullscreen .scout-card__role {
    font-size: 1.05rem;
    margin-bottom: 0.75rem;
  }

  .scout-card--fullscreen .scout-card__pvg-value {
    font-size: 1.25rem;
  }
}
</style>
